import React from 'react';
import {
  CtaEventDataType,
  CTA_TYPES,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import { TRACKING_LOCATIONS } from 'constants/tracking';
import type { WModuleGroupView } from '@zola/svc-web-api-ts-client';
import withCtaTracking from 'components/hoc/withCtaTracking';
import { wModuleViewToResponsivePicture } from 'libs/server/utils/moduleGroup';
import cx from 'classnames';
import {
  DESKTOP_MIN,
  LG_DESKTOP_MIN,
  TABLET_MIN,
  XS_MOBILE_MAX,
} from 'libs/universal/utils/device';

import styles from './MarketingModuleSection.module.less';

interface MarketingModuleSection {
  widget?: WModuleGroupView;
  className?: string;
  trackingData?: Pick<CtaEventDataType, 'business_unit' | 'section' | 'position'>;
}

const MarketingModuleSection: React.FC<MarketingModuleSection> = ({
  widget,
  className,
  trackingData,
}) => {
  const marketingModuleView = widget?.moduleViews?.[0];
  if (!marketingModuleView) {
    return null;
  }

  const marketingModulePicture = wModuleViewToResponsivePicture(marketingModuleView, [
    LG_DESKTOP_MIN,
    DESKTOP_MIN,
    TABLET_MIN,
    XS_MOBILE_MAX,
  ]);
  if (!marketingModulePicture) {
    return null;
  }

  const mapTrackingData = (): CtaEventDataType | undefined => {
    const tag = widget?.tag;
    if (!tag) return undefined;
    const defaultTrackingValues = {
      cta_type: CTA_TYPES.MARKETING_MODULE,
      group_id: 'EA_MARKETING_MODULES',
      cta_id: tag,
      location: TRACKING_LOCATIONS.EXPERT_ADVICE,
      cta: tag,
    };
    return Object.assign(defaultTrackingValues, trackingData);
  };

  const MarketingModule = () => (
    <a href={marketingModuleView.link_path}>{marketingModulePicture}</a>
  );
  const TrackedMarketingModule = withCtaTracking(MarketingModule);

  return (
    <div className={cx(styles.marketingModule, className)}>
      <TrackedMarketingModule trackingPayload={mapTrackingData()} />
    </div>
  );
};

export default MarketingModuleSection;
